// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__+Hx-m","fixedBackIcon":"index_fixedBackIcon__y6M3u","floor":"index_floor__XBoCl","full":"index_full__-HScD"};